export default function LogoBrand({ variant = 'nav', as: Tag = 'span', className = '' }) {
    const classes = ['logo-brand', `logo-brand--${variant}`, className].filter(Boolean).join(' ');

    return (
        <Tag className={classes}>
            <span className="logo-brand__lockup">
                Bypass<span className="logo-brand__vpn">VPN</span>
            </span>
        </Tag>
    );
}
